import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Deelname',
    lead: 'De deelnametrechter: van uitgenodigd tot structureel actief, plus dagelijkse betrokkenheidscijfers.',
    noScope: 'Kies een bedrijf om de deelnamecijfers te zien.',
    noDepartments: 'Geen enkele afdeling hier heeft statistieken die je mag zien.',
    disclaimer:
      'Alle waarden zijn indicatieve welzijnsinzichten en niet bedoeld als medische diagnose. Trends worden alleen getoond bij voldoende deelnemers (privacy-by-design).',
  },
  filters: {
    department: {
      label: 'Afdeling',
    },
    location: {
      label: 'Locatie',
      all: 'Alle locaties',
    },
  },
  funnel: {
    title: 'Deelnametrechter',
    pctOfPrevious: '{{pct}}% van vorige stap',
    steps: {
      invited: 'Uitgenodigd',
      activated: 'Geactiveerd',
      active_7d: 'Actief (7d)',
      active_30d: 'Actief (30d)',
      structurally_active: 'Structureel actief',
      needs_reactivation: 'Weer te activeren',
    },
  },
  rates: {
    title: 'Betrokkenheidscijfers',
    keys: {
      daily_sync_pct: 'Dagelijkse synchronisatie',
      ai_coach_use_pct: 'Gebruik AI-coach',
      challenge_participation_pct: 'Challenge-deelname',
      notification_open_pct: 'Notificatie-opens',
      break_adoption_pct: 'Pauze-adoptie',
      focus_rhythm_pct: 'Focusritme',
    },
  },
  breakdown: {
    department: 'Per afdeling',
    location: 'Per locatie',
    pilotGroup: 'Per pilotgroep',
    empty: 'Nog geen data om uit te splitsen.',
    pilotGroupEmpty: 'Nog geen pilot heeft deze afdeling in scope.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Afgeschermd',
      message:
        'Onvoldoende deelnemers ({{invited}}) voor privacyveilige weergave — minimaal {{min}} vereist.',
    },
    columns: {
      name: 'Naam',
      invited: 'Uitgenodigd',
      activated: 'Geactiveerd',
      active30d: 'Actief (30d)',
    },
  },
  status: {
    noData: '—',
  },
};
